// TODO: replace with Phil's Dropdown
import React from 'react'
import { Dropdown } from 'antd'
import PropTypes from 'prop-types'
import './MenuDropdown.scss'

const MenuDropdown  = ({
  items,
  trigger = "click",
  buttonLayout = "vertical",
  placement = "bottomRight",
  width,
  overlayClassName,
  children,
  ...dropdownProps // title
}) => {

  const renderChildren = () => {
    if (children) return children
    return buttonLayout === 'vertical'
      ? <i className="fal fa-ellipsis-v" />
      : <i className="fal fa-ellipsis-h" />
  }

  // popover classes
  const overlayClassNames = ['my-prime-dashboard-menu']
  if (overlayClassName) overlayClassNames.push(overlayClassName)

  return <>
    <Dropdown
      trigger={trigger}
      placement={placement}
      overlayStyle={width && { width }}
      overlayClassName={overlayClassNames.join(' ')}
      {...dropdownProps}
      menu={{items}}
    >
      <div className="menu-ellipsis">
        {renderChildren()}
      </div>
    </Dropdown>
  </>
}

MenuDropdown.propTypes = {
  title: PropTypes.string,
  buttonLayout: PropTypes.oneOf(['vertical', 'horizontal']),
  items: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.oneOf(['export', 'show', 'hide', 'plus', 'configure', 'delete']),
    text: PropTypes.string,
    action: PropTypes.func,
  })),
  overlayClassName: PropTypes.string,
  width: PropTypes.number,
}

export default MenuDropdown